(function () {
  'use strict';

  angular
    .module('vcconsult')
    .config(config);

  config.$inject = ['$stateProvider', '$logProvider'];

  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.consult', {
        url: '/consult',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;openconsultcounter&gt;</tt></h3><div ui-view="openconsultcounterview"></div>
              <h3 class="alert alert-info"><tt>&lt;closeconsult&gt;</tt></h3><div ui-view="closeconsultview"></div>
              <h3 class="alert alert-info"><tt>&lt;openconsultlist&gt;</tt></h3><div ui-view="openconsultlistview"></div>
              <h3 class="alert alert-info"><tt><recentconsultlist></recentconsultlist></tt></h3><div ui-view="recentconsultlistview"></div>
              <h3 class="alert alert-info"><tt>&lt;consultrecord patientid=""&gt;</tt></h3><div ui-view="consultrecordview"></div>
              <!--<h3 class="alert alert-info"><tt>&lt;consultsearch consult="" consultref="" parentsave=""&gt;</tt></h3><div ui-view="consultsearchview2"></div>-->
              <h3 class="alert alert-info"><tt>&lt;consulteditor consult="" mode="" onClose=""&gt;</tt></h3><div ui-view="consulteditview"></div>
              <!--<h3 class="alert alert-info"><tt>&lt;consulteditor consult="" mode="" onClose=""&gt;</tt></h3><div ui-view="consulteditview"></div>-->
              <h3 class="alert alert-info"><tt>&lt;consultlist consults="?"&gt;</tt></h3><div ui-view="consultlistview"></div>
            `
          }
        },
        onEnter: function () {
          $log.debug('debug/routes - playground.consult entered');
        }
      });


    $stateProvider
      .state('playground.consult.allcomponents', {
        url: '/allcomponents',
        resolve: {
          consult: function () {
            return '';
          },
          consultref: function () {
            return '';
          },
          maxmusterid: function () {
            return '571df9c97c01594fd0bbdf96';
          },
          someconsult: function (Consult) {
            return Consult.$find('572b31b07c01597e3e150923');
          },
          somefinish: function () {
            return function (doc, invdoc) {
              $log.debug('consult finish mock received: ', doc, invdoc);
            };
          },
          someotherconsult: function (Consult) {
            return Consult.$find('58f88208b148b776e918dd0d');
          },
          testpat: function () {
            return true;
          },
          allconsults: function (Consult) {
            return Consult.$search({active: true});
          },
          parentsavesearch: function () {
            return function (consult, consultref) {
              console.log('debug: dummy parentsave called for consultsearch with: ', consult, consultref);
            };
          },
          createNewConsult: function (Consult) {
            return Consult.$create({clientid: '58499f4c878f751a3eab5019', patientid: '58499f4c878f751a3eab5019'});
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'openconsultcounterview@playground.consult': {
            component: 'openconsultcounter',
            bindings: {}
          },
          'closeconsultview@playground.consult': {
            template: `<span class="btn btn-warning"
                             ng-click="vm.close(vm.consult, [{key: 'foo'}, {key: 'bar'}, {key: 'baz'}], true, vm.finish)">
                          Close Consult Modal
                       </span>`,
            controller: ['ConsultHelper', 'someotherconsult',
              function (ConsultHelper, consult) {
                let vm = this;
                $log.debug('closeconsultview controller called');
                vm.close = ConsultHelper.closeConsultModal;
                vm.consult = consult;
                vm.consult.examinations.$refresh();
              }],
            controllerAs: 'vm'
          },
          'openconsultlistview@playground.consult': {
            component: 'openconsultlist',
            bindings: {}
          },
          'recentconsultlistview@playground.consult': {
            component: 'recentconsultlist',
            bindings: {}
          },
          'consultsearchview@playground.consult': {
            component: 'consultsearch',
            bindings: {
              consult: 'consult',
              consultref: 'consultref',
              editinplace: 'eip'
            }
          },
          'consultsearchview2@playground.consult': {
            component: 'consultsearch',
            bindings: {
              consult: 'consult',
              consultref: 'consultref',
              parentsave: 'parentsavesearch'
            }
          },
          'consulteditview@playground.consult': {
            component: 'consulteditor',
            bindings: {
              consult: 'someconsult'
            }
          },
          'consultnewview@playground.consult': {
            component: 'consulteditor',
            bindings: {
              consult: 'createNewConsult'
            }
          },
          'consultlistview@playground.consult': {
            component: 'consultlist',
            bindings: {
              // consults: 'allconsults'
              patientid: 'maxmusterid'
            }
          },
          'consultrecordview@playground.consult': {
            component: 'consultrecord',
            bindings: {
              // consults: 'allconsults'
              patientid: 'maxmusterid'
            }
          }
        },
        onEnter: function () {
          console.log('playground.consult.allcomponents entered');
        }
      });


  }// all routes

// klammerfriedhof
}());
